// A response may commit only to the session that started the request. Comparing
// storage as well as the epoch closes the interval before a storage event runs.
export class AuthSession {
  constructor(readToken) {
    this.readToken = readToken
    this.epoch = 0
  }

  capture() {
    return { epoch: this.epoch, token: this.readToken() }
  }

  current(snapshot) {
    return snapshot.epoch === this.epoch && snapshot.token === this.readToken()
  }

  invalidate() {
    this.epoch += 1
  }
}

export const authTokenFromJSON = value => {
  try {
    const user = JSON.parse(value || "null")
    return typeof user?.token === "string" ? user.token : null
  } catch (e) {
    return null
  }
}

export const storedAuthToken = storage => {
  try {
    return authTokenFromJSON(storage.getItem("user"))
  } catch (e) {
    return null
  }
}
